import { Component } from '@angular/core';

@Component({
    selector: 'atlas-style-guide-palette',
    templateUrl: './style-guide-palette.component.html',
    styleUrls: ['./style-guide-palette.component.less'],
    standalone: false
})
export class StyleGuidePaletteComponent {}
